<template>
<div class="chapter">
<div class="inner_page">
<section class="" data-pdf-bookmark="Dedication" data-type="dedication" epub:type="dedication"><div class="dedication" id="d1e439"><h1 class="Nonprinting">Dedication</h1>
<p class="Dedicationded">For Errol and Olivia</p></div></section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication01.vue?57f498ed